const QaasRoute = authentication => {
  return [
    // fiexed expense Routes
    {
      path: "/qaases",
      name: "AllQaas",
      meta: { name: "All Qaas" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/QAAS"),
    },
    {
      path: "/QaasReport",
      name: "QaasReport",
      meta: { name: "Qaas Report" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/QAAS/qaasReport"),
    },
  ];
};

export default QaasRoute;
